import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { Spin, message } from 'antd';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './CalenderStyle.css';
import { useSelector, useDispatch } from 'react-redux';
import {
  getAllSessions,
  getSessionById,
} from '../../redux/features/sessions/sessionActions';
import {
  PrivateAxiosInstance,
  publicAxiosInstance,
} from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import { decryptData } from '../../utils/encryptData';
import ErrorBoundary from '../../utils/Errorboundary';

// Define your localizer
const localizer = momentLocalizer(require('moment'));

const EventCalender = () => {
  const [myEvents, setMyEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]); // To store events filtered by checkbox
  const [showMyEvents, setShowMyEvents] = useState(false); // Control which events to show (All or My)

  const dispatch = useDispatch();
  const { loading, data } = useSelector((state) => state.session);
  const { uid, rl } = useSelector((state) => state.auth);
  const userId = decryptData(uid);
  const role = decryptData(rl);

  const fetchDataByUserId = async () => {
    if (!userId) return;
    if (role === 'admin' || role === 'editor') {
      return;
    }

    try {
      const url = `${URLs.GET_REGISTER_SESSION_DETAILS_URL}?search=${userId}`; // Search by userId
      const res = await PrivateAxiosInstance.get(url); // API call
      const data = res?.data?.events;
      const eventIds = data?.map((item) => item?.eventId); //get user's register all session ids

      //no session
      if (eventIds === null || eventIds === undefined) {
        return;
      }

      let userEvents = [];
      for (const id of eventIds) {
        try {
          const res = await dispatch(getSessionById({ eventId: id })).unwrap();
          const eventData = res?.event; // Fetch data
          userEvents.push(eventData);
        } catch (err) {
          const errorMessage = err.error || 'Error fetching data';
          message.error(errorMessage);
        }
      }
      setMyEvents(userEvents); // Set user's events
    } catch (err) {
      message.error('Something went wrong during fetching events data');
    }
  };

  useEffect(() => {
    fetchDataByUserId();
    const fetchData = async () => {
      try {
        await dispatch(getAllSessions()).unwrap(); // Fetch all data
      } catch (err) {
        const errorMessage = err.error || 'Error fetching data';
        message.error(errorMessage);
      }
    };
    fetchData();
  }, [dispatch]);

  // If "My Events" is selected, filter events to show only the user's events
  // Show all events when "All Events" is selected
  useEffect(() => {
    if (showMyEvents) {
      setFilteredEvents(myEvents);
    } else {
      setFilteredEvents(data?.events || []);
    }
  }, [showMyEvents, data, myEvents]);

  const events =
    filteredEvents.map((event) => ({
      title: event.event_name || 'No Title',
      start:
        convertTimeToDate(event?.date, event?.startTime) || 'No Start Time',
      end: convertTimeToDate(event?.date, event?.endTime) || 'No End Time',
      allDay: false,
      className: event?.userId === userId ? 'my-event' : 'all-event',
    })) || [];

  function convertTimeToDate(dateString, timeString) {
    const date = new Date(dateString);
    const [time, modifier] = timeString.split(' ');
    let [hours, minutes] = time.split(':');

    if (modifier === 'PM' && hours < 12) {
      hours = parseInt(hours) + 12;
    }
    if (modifier === 'AM' && hours === '12') {
      hours = '0';
    }

    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    return date;
  }

  const handleCheckboxChange = (e) => {
    setShowMyEvents(e.target.value === 'my');
  };

  return (
    <div className="p-4 mt-[60px] px-[-30px] bg-background-secondary-color rounded-lg">
      <Spin spinning={loading} fullscreen />

      <ul className="items-center w-full md:max-w-[500px] text-sm font-medium text-gray-900 mb-5 bg-background-secondary-color sm:flex">
        <li className="w-full">
          <div className="flex items-center ps-3">
            <input
              id="all-checkbox-list"
              type="radio"
              name="event-filter"
              value="all"
              checked={!showMyEvents}
              onChange={handleCheckboxChange}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
            />
            <label
              htmlFor="all-checkbox-list"
              className="w-full font-poppins ms-2 text-lg font-medium text-gray-300"
            >
              All Events
            </label>
          </div>
        </li>
        <li className="w-full">
          <div className="flex items-center ps-3">
            <input
              id="my-checkbox-list"
              type="radio"
              name="event-filter"
              value="my"
              checked={showMyEvents}
              onChange={handleCheckboxChange}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
            />
            <label
              htmlFor="my-checkbox-list"
              className="w-full font-poppins ms-2 text-lg font-medium text-gray-300"
            >
              My Events
            </label>
          </div>
        </li>
      </ul>

      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        className="custom-calendar"
        style={{
          height: 650,
          backgroundColor: '#191919',
          fontSize: '16px',
          color: 'rgb(107 114 128)',
        }}
        views={{
          month: true,
          agenda: true,
        }}
        defaultView="month"
      />
    </div>
  );
};

export default EventCalender;
